import {
  EntityDisplayConfig,
  RawEntityDisplayConfig,
  RawEntityDisplayConfigField
} from '../interfaces/entity-display-config';
import { deepEqual } from '../utils/object';

export function EntityDisplayConfigFactory<EntityType>(
  rawConfig: RawEntityDisplayConfig<EntityType>
): EntityDisplayConfig {
  const { fields, values, previous_values: previousValues } = rawConfig.template;

  const newFields = fields.map(field => ({
    name: field.name,
    type: field.type,
    displayName: field.display_name,
    value: getDisplayValue(field, values),
    previousValue: getDisplayValue(field, previousValues),
    HelperText: EntityDisplayDetailsHelperText(field)
  }));

  return {
    fields: newFields,
    hasDiff: previousValues ? !deepEqual(values, previousValues) : false
  };
}

function getDisplayValue(
  field: RawEntityDisplayConfigField,
  values:
    | RawEntityDisplayConfig<unknown>['template']['values']
    | RawEntityDisplayConfig<unknown>['template']['previous_values']
) {
  const { type, name } = field;

  if (values) {
    const value = values[name];

    if (value === undefined || value === null) {
      return '-';
    }

    switch (type) {
      case 'PASSWORD':
        return '*'.repeat((value as string).length);

      case 'STRING':
      case 'LONG': {
        return value as string;
      }

      case 'BOOLEAN':
        return value ? 'True' : 'False';

      default:
        return '-';
    }
  }

  return '-';
}

export function EntityDisplayDetailsHelperText(field: RawEntityDisplayConfigField) {
  const { value_helper_text: helperText } = field;
  return helperText?.text;
}
